import { render, staticRenderFns } from "./software.vue?vue&type=template&id=3ee8a604&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8a604",
  null
  
)

export default component.exports